import { Component } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { PaymentService } from '../payment.service';
import { PdfService } from '../pdf.service';

@Component({
  selector: 'app-bookingdetails',
  templateUrl: './bookingdetails.component.html',
  styleUrls: ['./bookingdetails.component.scss'],
})
export class BookingdetailsComponent  {
  purrchaseItems: any;
  dateFormat;
  loader:boolean=false;
  id;
  url;
  appt:boolean ;
  flatNo;
  flatName;
  doorNbr;
  invoiceObj;
  invoiceId;
  serviceName;
  name;
  contactNbr;
  invoiceDate;
  amount;
  billAmount;
  payAmount;
  tax;
  startDate;
  patmtStatus;
  statusOrder;
  paymentStatus:any=[{id:1,name:"Not Paid"},{id:2,name:"Paid"},{id:3,name:"Pending"}];
orderStatus:any=[{id:5,name:"Cancelled"},{id:7,name:"Pending Allocation"},{id:12,name:"Allocated"},{id:10,name:"Scheduled"},{id:3,name:"Completed"},{id:11,name:"Partially Fixed"}]
  endDate;
  date:boolean=false;
  orderItems:any;
  payTotal;
  orderType;
  purType:boolean;
  constructor(   private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public pdf: PdfService,
    public translate: TranslateService,
    public payment:PaymentService,
    public auth: AuthService,  public location: LocationService) { }
ionViewWillEnter(){
  this.loader = true;
  this.orderType = sessionStorage.getItem('orderType');
  if(this.orderType==2){
    this.purType=true;
  }else{
    this.purType=false;
  }
  this.url = window.location.href;
  this.dateFormat = this.auth.getDateformat();
  this.id = window.location.href.split("/").pop();
  if(this.url.includes('booking-details1')){
    this.getSubscription();
    this.date=true;   
  }else{
    this.getRequest();  
  }
 
}

getSubscription(){
  this.service.getCustItemSubsById(this.id).subscribe((res:any)=>{
    if(res){
      this.purrchaseItems = res;   
      this.invoiceId=res.customerInvoiceId;
      this.serviceName = res.services[0].name;   
      this.payTotal = res.payTotal; 
      if(res.addresses){
        this.location.regionId=res.addresses[0].regionId;
        this.location.street=res.addresses[0].street;
        this.location.stateId=res.addresses[0].stateId;
        this.location.cityId=res.addresses[0].cityId;
        this.location.zipcode=res.addresses[0].zipcode; 
        this.appt=res.addresses[0].appt;
        this.doorNbr=res.addresses[0].doorNbr;
        this.flatName=res.addresses[0].flatName;
        this.flatNo=res.addresses[0].flatNo;    
        }
      }
      if(window['url'].includes('3.209.13.42')){
        this.payment.setPaymentParamters(this.purrchaseItems,1)
        // this.payment.payWithRazorpay(this.purrchaseItems,1)
       }else{
        this.payment.setPaymentParamters(this.purrchaseItems,2)
        // this.payment.payWithRazorpay(this.purrchaseItems,1)
       }
    this.getInvoice();
  },
    err => {
      this.loader = false;
      this.handler.err(err.error)
    })
}

getRequest(){
  this.service.getOrderById(this.id).subscribe((res:any) => {
    if (res) {
     this.purrchaseItems = res;
     this.amount = res.orderAmountStr;
     this.loader =false;
     this.orderItems = res?.itemOrders
     this.flatName=res?.flatName;
     this.flatNo=res?.flatNo;       
      this.location.regionId=res?.delRegion;
      this.location.street=res?.delStreet;
      this.location.stateId=res?.delState;
      this.location.cityId=res?.delCity;
      this.location.zipcode=res?.address?.zipcode; 
      this.doorNbr=res?.delDoorNbr;
      if(!this.flatName){
        this.appt = false;
      }else{
        this.appt = true;
      }  
      this.paymentStatus.map(dat=>{
        if(res.paymtStatus==dat.id){
          this.patmtStatus=dat.name;
        }      
      })
      this.orderStatus.map(dat1=>{
        if(res.status==dat1.id){
          this.statusOrder=dat1.name;
        }
      }) 
      if(window['url'].includes('3.209.13.42')){
      this.payment.setPaymentParamters(this.purrchaseItems,1)
      // this.payment.payWithRazorpay(this.purrchaseItems,1)
     }else{
      this.payment.setPaymentParamters(this.purrchaseItems,2)
      // this.payment.payWithRazorpay(this.purrchaseItems,1)
     }
    
      }
    // this.getInvoice();
  },
    err => {
      this.loader = false;
      this.handler.err(err.error)
    })
}
getInvoice(){
  this.service.getInvoiceById(this.invoiceId).subscribe((res: any) => {
    this.invoiceObj = res;
    this.invoiceDate = res.invoiceDate;   
    this.name = res.payer.name;
    this.contactNbr = res.payer.contactNbrMob;
    this.billAmount = res.billAmountStr;
    this.payAmount = res.payTotalStr;
    this.tax = res.taxAmtStr; 
    this.startDate = res.billPeriodStartDate;
    this.endDate = res.billPeriodEndDate;
    this.loader = false; 
  })
}

pay(){
  if(this.purrchaseItems.discountAmountStr > 0 || this.purrchaseItems.creditPointsStr > 0){
    sessionStorage.setItem('PayCost', this.amount)
    this.router.navigate(['orders-pay-options/',this.id])
  }else{
    sessionStorage.setItem('PayCost', this.amount)
    this.router.navigate(['pending-pay/',this.id])
  } 
}
}

